module.exports = __webpack_public_path__ + "img/defesa-civil-rs.d48350e8.png";